$shm_hitalama_map_rights $mol_view
	map $shm_hitalama_map
	team? null
	client_id? \
	message? \
	grant_client? \
	grant_rank? 0
	grant_success? \
	access_revision? 0
	auto /
		^
		<= grant_pending_auto null
	sub <= rows /
		<= Map_type $mol_text
			text <= map_type \
		<= Team_member_label $mol_labeler
			title \Участник команды
			content /
				<= Team_member $mol_select
					hint \Выберите участника
					dictionary <= team_member_options *
					value? <=> client_id? \
		<= Client_label $mol_labeler
			title \ID клиента
			content /
				<= Client_id $mol_string
					hint \XXXXXXXX_XXXXXXXX
					value? <=> client_id? \
		<= Actions $mol_view
			sub /
				<= Grant_read $mol_button_minor
					title \Выдать чтение
					enabled <= grant_enabled false
					click? <=> grant_read? null
				<= Grant_write $mol_button_major
					title \Выдать запись
					enabled <= grant_enabled false
					click? <=> grant_write? null
		<= Message $mol_text
			text <= message? \
		<= Access_title $mol_view
			sub / \Выданные права
		<= Access_empty $mol_text
			text \Индивидуальные права не выданы
		<= Access_list $mol_list
			rows <= access_rows /
	Access_row* $mol_view
		sub /
			<= Access_identity* $mol_view
				sub /
					<= Access_person* $shm_hitalama_profile_badge
						name <= access_name* \
						avatar_uri <= access_avatar_uri* \
					<= Access_id* $mol_view
						sub / <= access_id* \
			<= Access_actions* $mol_view
				sub /
					<= Access_rank* $mol_select
						dictionary <= access_rank_options *
						value? <=> access_rank*? \read
						enabled <= access_change_enabled* false
						Filter null
					<= Access_revoke* $mol_button_minor
						title \Отозвать
						enabled <= access_change_enabled* false
						click? <=> access_revoke*? null
